import React, { Component } from "react";
import { styles } from "../styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
} from "@material-ui/core";
import ApproveModal from "../components/ApproveModal";
import CustomIcon from "../components/CustomIcon";
import check from "../images/check.svg";
import dataProvider from "../trucknetRestClient";

class ApproveComponent extends Component {
  state = {
    isOpenApprovalModal: false,
  };

  render() {
    const handleOpen = () => {
      this.setState({ isOpenApprovalModal: true });
    };
    const handleClose = () => {
      this.setState({ isOpenApprovalModal: false });
    };

    const handleApprove = async () => {
      try {
        await dataProvider("UPDATE", "admin/companies", {
          id: this.props.record._id,
          data: { isSuperAdminApproved: true },
          previousData: {},
        });
        handleClose();
      } catch (error) {
        console.error("Update failed:", error);
      }
    };

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {this.props.record.isSuperAdminApproved ? (
          <CustomIcon src={check} />
        ) : (
          <Button style={styles.chip} onClick={handleOpen}>
            Approve
          </Button>
        )}
        {this.state.isOpenApprovalModal && (
          <Dialog open maxWidth={false}>
            <DialogContent>
              <ApproveModal {...this.props} />
            </DialogContent>
            <DialogActions>
              <Button color="" onClick={handleClose}>
                Close
              </Button>
              <Button color="primary" onClick={handleApprove}>
                Approve
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }
}

export default ApproveComponent;



// WEBPACK FOOTER //
// ./src/companies/ApproveComponent.js